/**
 * 格式化时间戳为指定格式的日期字符串
 * @param timestamp 时间戳（毫秒）
 * @param format 日期格式，默认为 'yyyy-MM-dd HH:mm:ss'
 * @returns 格式化后的日期字符串
 *
 * 格式说明：
 *   yyyy - 四位年份
 *   MM   - 两位月份 (01-12)
 *   dd   - 两位日期 (01-31)
 *   HH   - 24小时制小时 (00-23)
 *   mm   - 分钟 (00-59)
 *   ss   - 秒 (00-59)
 *   SSS  - 毫秒 (000-999)
 *   E    - 星期 (日、一、二等)
 *   aa   - 上午/下午
 *
 * 示例：
 *   formatTimestamp(1629987600000) → "2021-08-26 14:20:00"
 *   formatTimestamp(1629987600000, 'yyyy/MM/dd HH:mm:ss.SSS') → "2021/08/26 14:20:00.000"
 *   formatTimestamp(1629987600000, 'yyyy年MM月dd日 HH时mm分 E aa') → "2021年08月26日 14时20分 四 下午"
 */
export function formatTimestamp(
  timestamp: number,
  format: string = "yyyy-MM-dd HH:mm:ss",
): string {
  if (!timestamp) {
    return "";
  }
  try {
    if (typeof timestamp === "string") {
      timestamp = Number(timestamp);
    }
  } catch (error) {
    console.error(error);
  }
  const date = new Date(timestamp);

  // 验证时间戳有效性
  if (isNaN(date.getTime())) {
    throw new Error("Invalid timestamp provided");
  }

  // 星期映射
  const weekdays = ["日", "一", "二", "三", "四", "五", "六"];

  // 提取时间各部分
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();
  const dayOfWeek = date.getDay();

  // 上午/下午
  const amOrPm = hours >= 12 ? "下午" : "上午";

  // 替换各种格式标记
  return format
    .replace(/yyyy/g, year.toString())
    .replace(/yy/g, year.toString().slice(-2))
    .replace(/MM/g, month.toString().padStart(2, "0"))
    .replace(/M/g, month.toString())
    .replace(/dd/g, day.toString().padStart(2, "0"))
    .replace(/d/g, day.toString())
    .replace(/HH/g, hours.toString().padStart(2, "0"))
    .replace(/H/g, hours.toString())
    .replace(/hh/g, (hours % 12 || 12).toString().padStart(2, "0"))
    .replace(/h/g, (hours % 12 || 12).toString())
    .replace(/mm/g, minutes.toString().padStart(2, "0"))
    .replace(/m/g, minutes.toString())
    .replace(/ss/g, seconds.toString().padStart(2, "0"))
    .replace(/s/g, seconds.toString())
    .replace(/SSS/g, milliseconds.toString().padStart(3, "0"))
    .replace(/SS/g, milliseconds.toString().padStart(3, "0").slice(0, 2))
    .replace(/S/g, milliseconds.toString())
    .replace(/E/g, weekdays[dayOfWeek])
    .replace(/aa/g, amOrPm);
}
